import { Action, handleActions } from 'redux-actions'
import { CompanyRankDto } from '../../../services/api.types'
import { getCompanyRanking, getCompanyRankingSuccess } from './CompanyRankingActions'

class State {
  periodPercentage = 100
  companyRanking: CompanyRankDto[] = []
  companyRankingLoading = false
  companyIsExcludedFromRanking = false
}

export const companyRanking = handleActions<State, any>(
  {
    [String(getCompanyRanking)]: (state: State): State => ({
      ...state,
      companyRankingLoading: true,
    }),
    [String(getCompanyRankingSuccess)]: (
      state: State,
      { payload: { periodPercentage, companyRanking = [], companyIsExcludedFromRanking = false } }: Action<any>,
    ): State => ({
      ...state,
      periodPercentage,
      companyRanking,
      companyRankingLoading: false,
      companyIsExcludedFromRanking,
    }),
  },
  new State(),
)

export { State as CompanyRankingState }
